
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33740',
  depVersions: {
  "documents-public-ui": "static-1.33740",
  "client-types": "static-1.442",
  "documents-lib": "static-1.33745",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1817",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5290",
  "hs-test-utils": "static-1.7679",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11123",
  "I18n": "static-7.1541",
  "jasmine-immutable": "static-1.2716",
  "jasmine-runner": "static-1.6152",
  "lodash": "static-1.3",
  "quartz": "static-1.6582",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16331",
  "reporting-data": "static-1.66097",
  "reporting-testing-lib": "static-1.8030",
  "reporting-visualizations": "static-1.58173",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4444",
  "webpack-env": "static-1.54",
  "atom": "static-1.4771",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2163",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.698",
  "customer-data-filters-ui": "static-1.38533",
  "customer-data-objects": "static-1.7311",
  "customer-data-property-utils": "static-1.7769",
  "data-fetching-client": "static-1.9373",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4234",
  "flux-actions": "static-1.297",
  "FormsCommonComponents": "static-1.85004",
  "FormUrlGenerator": "static-2.4430",
  "foundations-components": "static-1.7303",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11431",
  "icons": "static-2.613",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6842",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3558",
  "property-translator": "static-1.5112",
  "quartz-config": "static-1.360",
  "quartz-core": "static-1.5801",
  "quick-fetch": "static-1.3636",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5084",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7859",
  "reference-resolvers-lite": "static-1.7790",
  "report-customization-components": "static-1.12231",
  "reporting-enablement": "static-1.21756",
  "reporting-reports": "static-1.65775",
  "reporting-snowflake": "static-1.54715",
  "reporting-ui-components": "static-2.63369",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4303",
  "sales-content-partitioning": "static-1.8633",
  "SalesContentIndexUI": "static-3.8744",
  "sanitize": "static-1.4174",
  "sanitize-text": "static-1.7840",
  "self-service-api": "static-1.9924",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1457",
  "signup-constants": "static-1.18209",
  "signup-ui-lego-core": "static-1.20219",
  "signup-ui-url-generator": "static-2.7730",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4472",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10695",
  "ui-addon-i18n": "static-1.10827",
  "ui-addon-react-router-dom": "static-1.9247",
  "ui-addon-upgrades": "static-9.17420",
  "ui-asset-management-lib": "static-1.10559",
  "ui-images": "static-2.1062",
  "UIComponents": "static-3.8070",
  "usage-tracker": "static-1.7035",
  "usage-tracker-container": "static-1.7025",
  "usage-tracker-core": "static-1.6885",
  "usage-tracker-public": "static-1.6846",
  "viral-links-lib": "static-1.6719",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3134",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2859",
  "quartz-webpack": "static-1.2806",
  "ai-components-ui-library": "static-1.8097",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4530",
  "foundations-theming": "static-1.4101",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4721",
  "foundations-theming-base": "static-1.3086",
  "HeadJS": "static-2.690",
  "framer-motion": "static-1.65",
  "hs-test-utils-bend-plugin": "static-1.2790",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4030",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7623",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3367",
  "persist-promise": "static-1.3385",
  "reporting-client-types": "static-1.2355",
  "hs-story-utils": "static-1.9127",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9213",
  "hubspotter-http": "static-1.4386",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6950",
  "crm-message-bus": "static-1.42103",
  "customer-data-filters-ui-msw-helpers": "static-1.20967",
  "customer-data-objects-ui-components": "static-1.12701",
  "customer-data-reference-ui-components": "static-1.12837",
  "customer-data-ui-utilities": "static-1.9525",
  "framework-builder-read-service-client": "static-1.3755",
  "framework-data-schema-quick-fetch": "static-1.6470",
  "framework-data-schema-resolvers": "static-1.6565",
  "inbound-db-properties-service-client": "static-1.3586",
  "multi-account-reference-resolvers": "static-1.665",
  "onboarding-tours": "static-1.16131",
  "reporting-datasets-permissions-lib": "static-1.12719",
  "ui-addon-teams": "static-1.21090",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67317",
  "customer-data-properties": "static-1.50492",
  "forms-ai-lib": "static-1.3840",
  "forms-utils-lib": "static-1.11978",
  "foundations-components-test-utils": "static-1.4786",
  "react-dnd-compat": "static-1.4323",
  "react-tinymce": "static-1.54360",
  "tinymce-config": "static-2.53486",
  "ui-gdpr-components": "static-1.10045",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3572",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.979",
  "ui-fonts": "static-1.385",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.770",
  "mobile-manifest-mixins": "static-1.463",
  "quartz-auth": "static-1.257",
  "quartz-head": "static-1.247",
  "quartz-i18n": "static-1.257",
  "quartz-test": "static-1.257",
  "batch-promise": "static-1.1228",
  "external-options-client-types": "static-1.3890",
  "react-colorpicker": "static-2.9912",
  "copilot-toolkit": "static-1.10288",
  "data-quality-ui-library": "static-1.12099",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40431",
  "reporting-insights-lib": "static-1.888",
  "reporting-plugins": "static-1.9857",
  "ui-addon-draggable-compat": "static-2.3953",
  "ui-addon-opt": "static-4.8089",
  "ui-shepherd-react": "static-3.9842",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24456",
  "hubspot-apollo-client": "static-1.4580",
  "sales-templates-service-types-lib": "static-1.3901",
  "ui-business-units-lib": "static-1.8720",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5330",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3812",
  "upgrade-management-service-types": "static-1.4207",
  "timezone-utils": "static-2.4944",
  "bender-build-tools": "static-1.2805",
  "chatspot-core": "static-1.19958",
  "chirp-fetch": "static-1.1581",
  "bend-plugin-foundations-theming": "static-1.2584",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3530",
  "crm-pipelines-api-client-types": "static-1.3872",
  "multi-currency-client-types": "static-1.3429",
  "getting-started-shared-tasks": "static-1.17602",
  "growth-data-modal": "static-1.5030",
  "growth-onboarding-confetti": "static-1.2750",
  "growth-onboarding-next-action-utils": "static-1.1194",
  "navigation-components": "static-1.16979",
  "onboarding-tours-client": "static-1.4345",
  "onboarding-tours-utils": "static-1.197",
  "ui-shepherd-tracker": "static-1.7223",
  "ui-universal-auth": "static-1.8557",
  "user-context": "static-1.4793",
  "cms-field-types": "static-1.4507",
  "content-icons-ui": "static-1.2117",
  "integrations-lib": "static-1.15096",
  "calling-global-api": "static-1.63312",
  "calling-internal-common": "static-1.30988",
  "calling-lifecycle-internal": "static-1.64694",
  "calling-lifecycle-messages": "static-1.56988",
  "commerce-products-lib": "static-1.8552",
  "crm-links": "static-1.5952",
  "file-manager-components": "static-1.22580",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.352",
  "inbounddb-objects-service-types": "static-1.3957",
  "meetings-icalendar-utils-lib": "static-1.333",
  "object-builder-ui-client": "static-1.47658",
  "pipeline-validation-client-types": "static-1.3693",
  "property-value-citations": "static-1.1106",
  "pulse": "static-1.189",
  "smart-property-lib": "static-1.5529",
  "tiered-pricing": "static-1.666",
  "ui-addon-iframeable": "static-1.8715",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19288",
  "tinymce-themes": "static-1.55456",
  "data-token-picker": "static-1.15886",
  "hub-http-contrib": "static-1.2747",
  "interframe": "static-3.4492",
  "tinymce-data": "static-1.39571",
  "tinymce-plugins": "static-1.56600",
  "ui-addon-sales-email": "static-1.4913",
  "hubspotter-http-shared-msw-handlers": "static-1.9211",
  "magpie-lib": "static-1.5275",
  "magpie-types": "static-1.4735",
  "simple-logging-lib": "static-1.2750",
  "content-assistance-lib": "static-1.7303",
  "dashboard-lib": "static-1.80221",
  "ExportDialog": "static-6.10088",
  "hubspot-prosemirror": "static-1.17337",
  "hubspot-prosemirror-plugins": "static-1.17329",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8386",
  "campaign-roi-lib": "static-1.7986",
  "feedback-loader": "static-1.28676",
  "commerce-analytics-service-client": "static-1.3387",
  "onboarding-scopes": "static-1.6142",
  "apollo-link-hub-http": "static-2.4348",
  "hubspot-apollo-cache": "static-1.39",
  "growth-monetization-service-types": "static-1.4223",
  "nav-client-types": "static-1.2031",
  "purchase-motions-api": "static-1.5333",
  "trials-service-types": "static-1.3624",
  "chatspot-client-types": "static-1.10348",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.426",
  "getting-started-shared-tasks-store": "static-1.16720",
  "cohere-reconnect-lib": "static-1.49",
  "integrations-error-boundary-lib": "static-1.12511",
  "integrations-tracking-lib": "static-1.5283",
  "native-integrations-shared-strings": "static-1.7487",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10073",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30994",
  "shared-worker-versioning": "static-1.10716",
  "calling-usage-tracker": "static-1.6238",
  "calling-orchestration-shared-library": "static-1.34506",
  "customer-data-tracking": "static-1.6560",
  "products-iframe-lib": "static-1.7080",
  "products-ui-components-shared-msw-handlers": "static-1.9595",
  "location-customization-utils-lib": "static-1.8244",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3856",
  "video-components-external": "static-1.10264",
  "video-data-lib": "static-1.33922",
  "directed-graph": "static-1.637",
  "event-emitter": "static-1.624",
  "breeze-intelligence-kit": "static-1.5169",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9296",
  "fsm": "static-1.3430",
  "policy-lib": "static-1.6501",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9359",
  "navigation-messaging": "static-1.6306",
  "FileManagerLib": "static-1.38220",
  "NamespacedHubStyle": "static-2.8807",
  "FileManagerCore": "static-1.38079",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11857",
  "layout-dnd-utils": "static-1.10832",
  "react-codemirror": "static-1.10303",
  "ui-addon-emoji-picker": "static-1.9589",
  "ui-brand-identity-lib": "static-1.13427",
  "ui-addon-video-player": "static-1.8420",
  "ui-coaching-tips": "static-1.27676",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22657",
  "EmailSignatureEditor": "static-1.23745",
  "eligibility-engine-service-types": "static-1.2905",
  "universal-page-editor-lib": "static-1.2696",
  "calling-orchestration-schema": "static-1.34731",
  "sales-views-client-types": "static-1.3992",
  "crm-record-cards-service-types": "static-1.3360",
  "content-media-composition-data-lib": "static-1.11031",
  "content-media-compositions": "static-2.15038",
  "media-bridge-lib": "static-1.18404",
  "trellis-story-utils": "static-1.4222",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5466",
  "FileManagerImages": "static-1.35731",
  "video-components": "static-1.12267",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4233",
  "video-embed": "static-1.34756",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67392",
  "layout-data-lib": "static-1.9157",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6285",
  "commerce-tours-lib": "static-1.5563",
  "growth-onboarding-reliability": "static-1.4787",
  "sales-checkout-service-client": "static-1.3399",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21127",
  "sales-email-signature-service-client": "static-1.3540",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21115",
  "outpost": "static-1.3912",
  "advanced-menus-core": "static-1.14651",
  "advanced-menus-lib": "static-1.11642",
  "ui-memberships-settings-lib": "static-1.33161",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14650",
  "simple-menus-lib": "static-1.16167"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33740",
  "client-types": "/client-types/static-1.442",
  "documents-lib": "/documents-lib/static-1.33745",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1817",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5290",
  "hs-test-utils": "/hs-test-utils/static-1.7679",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11123",
  "I18n": "/I18n/static-7.1541",
  "jasmine-immutable": "/jasmine-immutable/static-1.2716",
  "jasmine-runner": "/jasmine-runner/static-1.6152",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6582",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16331",
  "reporting-data": "/reporting-data/static-1.66097",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8030",
  "reporting-visualizations": "/reporting-visualizations/static-1.58173",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4444",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4771",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2163",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.698",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38533",
  "customer-data-objects": "/customer-data-objects/static-1.7311",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7769",
  "data-fetching-client": "/data-fetching-client/static-1.9373",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4234",
  "flux-actions": "/flux-actions/static-1.297",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85004",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4430",
  "foundations-components": "/foundations-components/static-1.7303",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11431",
  "icons": "/icons/static-2.613",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6842",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3558",
  "property-translator": "/property-translator/static-1.5112",
  "quartz-config": "/quartz-config/static-1.360",
  "quartz-core": "/quartz-core/static-1.5801",
  "quick-fetch": "/quick-fetch/static-1.3636",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5084",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7859",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7790",
  "report-customization-components": "/report-customization-components/static-1.12231",
  "reporting-enablement": "/reporting-enablement/static-1.21756",
  "reporting-reports": "/reporting-reports/static-1.65775",
  "reporting-snowflake": "/reporting-snowflake/static-1.54715",
  "reporting-ui-components": "/reporting-ui-components/static-2.63369",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4303",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8633",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8744",
  "sanitize": "/sanitize/static-1.4174",
  "sanitize-text": "/sanitize-text/static-1.7840",
  "self-service-api": "/self-service-api/static-1.9924",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1457",
  "signup-constants": "/signup-constants/static-1.18209",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20219",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7730",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4472",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10695",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10827",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9247",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17420",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10559",
  "ui-images": "/ui-images/static-2.1062",
  "UIComponents": "/UIComponents/static-3.8070",
  "usage-tracker": "/usage-tracker/static-1.7035",
  "usage-tracker-container": "/usage-tracker-container/static-1.7025",
  "usage-tracker-core": "/usage-tracker-core/static-1.6885",
  "usage-tracker-public": "/usage-tracker-public/static-1.6846",
  "viral-links-lib": "/viral-links-lib/static-1.6719",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3134",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2859",
  "quartz-webpack": "/quartz-webpack/static-1.2806",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8097",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4530",
  "foundations-theming": "/foundations-theming/static-1.4101",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4721",
  "foundations-theming-base": "/foundations-theming-base/static-1.3086",
  "HeadJS": "/HeadJS/static-2.690",
  "framer-motion": "/framer-motion/static-1.65",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2790",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4030",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7623",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3367",
  "persist-promise": "/persist-promise/static-1.3385",
  "reporting-client-types": "/reporting-client-types/static-1.2355",
  "hs-story-utils": "/hs-story-utils/static-1.9127",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9213",
  "hubspotter-http": "/hubspotter-http/static-1.4386",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6950",
  "crm-message-bus": "/crm-message-bus/static-1.42103",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20967",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12701",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12837",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9525",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3755",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6470",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6565",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3586",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.665",
  "onboarding-tours": "/onboarding-tours/static-1.16131",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12719",
  "ui-addon-teams": "/ui-addon-teams/static-1.21090",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67317",
  "customer-data-properties": "/customer-data-properties/static-1.50492",
  "forms-ai-lib": "/forms-ai-lib/static-1.3840",
  "forms-utils-lib": "/forms-utils-lib/static-1.11978",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4786",
  "react-dnd-compat": "/react-dnd-compat/static-1.4323",
  "react-tinymce": "/react-tinymce/static-1.54360",
  "tinymce-config": "/tinymce-config/static-2.53486",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10045",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3572",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.979",
  "ui-fonts": "/ui-fonts/static-1.385",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.770",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.463",
  "quartz-auth": "/quartz-auth/static-1.257",
  "quartz-head": "/quartz-head/static-1.247",
  "quartz-i18n": "/quartz-i18n/static-1.257",
  "quartz-test": "/quartz-test/static-1.257",
  "batch-promise": "/batch-promise/static-1.1228",
  "external-options-client-types": "/external-options-client-types/static-1.3890",
  "react-colorpicker": "/react-colorpicker/static-2.9912",
  "copilot-toolkit": "/copilot-toolkit/static-1.10288",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12099",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40431",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.888",
  "reporting-plugins": "/reporting-plugins/static-1.9857",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3953",
  "ui-addon-opt": "/ui-addon-opt/static-4.8089",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9842",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24456",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4580",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3901",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8720",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5330",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3812",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4207",
  "timezone-utils": "/timezone-utils/static-2.4944",
  "bender-build-tools": "/bender-build-tools/static-1.2805",
  "chatspot-core": "/chatspot-core/static-1.19958",
  "chirp-fetch": "/chirp-fetch/static-1.1581",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2584",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3530",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3872",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3429",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17602",
  "growth-data-modal": "/growth-data-modal/static-1.5030",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2750",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1194",
  "navigation-components": "/navigation-components/static-1.16979",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4345",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.197",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7223",
  "ui-universal-auth": "/ui-universal-auth/static-1.8557",
  "user-context": "/user-context/static-1.4793",
  "cms-field-types": "/cms-field-types/static-1.4507",
  "content-icons-ui": "/content-icons-ui/static-1.2117",
  "integrations-lib": "/integrations-lib/static-1.15096",
  "calling-global-api": "/calling-global-api/static-1.63312",
  "calling-internal-common": "/calling-internal-common/static-1.30988",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64694",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56988",
  "commerce-products-lib": "/commerce-products-lib/static-1.8552",
  "crm-links": "/crm-links/static-1.5952",
  "file-manager-components": "/file-manager-components/static-1.22580",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.352",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3957",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.333",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47658",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3693",
  "property-value-citations": "/property-value-citations/static-1.1106",
  "pulse": "/pulse/static-1.189",
  "smart-property-lib": "/smart-property-lib/static-1.5529",
  "tiered-pricing": "/tiered-pricing/static-1.666",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8715",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19288",
  "tinymce-themes": "/tinymce-themes/static-1.55456",
  "data-token-picker": "/data-token-picker/static-1.15886",
  "hub-http-contrib": "/hub-http-contrib/static-1.2747",
  "interframe": "/interframe/static-3.4492",
  "tinymce-data": "/tinymce-data/static-1.39571",
  "tinymce-plugins": "/tinymce-plugins/static-1.56600",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4913",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9211",
  "magpie-lib": "/magpie-lib/static-1.5275",
  "magpie-types": "/magpie-types/static-1.4735",
  "simple-logging-lib": "/simple-logging-lib/static-1.2750",
  "content-assistance-lib": "/content-assistance-lib/static-1.7303",
  "dashboard-lib": "/dashboard-lib/static-1.80221",
  "ExportDialog": "/ExportDialog/static-6.10088",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17337",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17329",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8386",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7986",
  "feedback-loader": "/feedback-loader/static-1.28676",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3387",
  "onboarding-scopes": "/onboarding-scopes/static-1.6142",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4348",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.39",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4223",
  "nav-client-types": "/nav-client-types/static-1.2031",
  "purchase-motions-api": "/purchase-motions-api/static-1.5333",
  "trials-service-types": "/trials-service-types/static-1.3624",
  "chatspot-client-types": "/chatspot-client-types/static-1.10348",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.426",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16720",
  "cohere-reconnect-lib": "/cohere-reconnect-lib/static-1.49",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12511",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5283",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7487",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10073",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30994",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10716",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6238",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34506",
  "customer-data-tracking": "/customer-data-tracking/static-1.6560",
  "products-iframe-lib": "/products-iframe-lib/static-1.7080",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9595",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8244",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3856",
  "video-components-external": "/video-components-external/static-1.10264",
  "video-data-lib": "/video-data-lib/static-1.33922",
  "directed-graph": "/directed-graph/static-1.637",
  "event-emitter": "/event-emitter/static-1.624",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5169",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9296",
  "fsm": "/fsm/static-1.3430",
  "policy-lib": "/policy-lib/static-1.6501",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9359",
  "navigation-messaging": "/navigation-messaging/static-1.6306",
  "FileManagerLib": "/FileManagerLib/static-1.38220",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8807",
  "FileManagerCore": "/FileManagerCore/static-1.38079",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11857",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10832",
  "react-codemirror": "/react-codemirror/static-1.10303",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9589",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13427",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8420",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27676",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22657",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23745",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2905",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2696",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34731",
  "sales-views-client-types": "/sales-views-client-types/static-1.3992",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3360",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11031",
  "content-media-compositions": "/content-media-compositions/static-2.15038",
  "media-bridge-lib": "/media-bridge-lib/static-1.18404",
  "trellis-story-utils": "/trellis-story-utils/static-1.4222",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5466",
  "FileManagerImages": "/FileManagerImages/static-1.35731",
  "video-components": "/video-components/static-1.12267",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4233",
  "video-embed": "/video-embed/static-1.34756",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67392",
  "layout-data-lib": "/layout-data-lib/static-1.9157",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6285",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5563",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4787",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3399",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21127",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3540",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21115",
  "outpost": "/outpost/static-1.3912",
  "advanced-menus-core": "/advanced-menus-core/static-1.14651",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11642",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33161",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14650",
  "simple-menus-lib": "/simple-menus-lib/static-1.16167"
}
};
